import React from "react";

export const Features = (props) => {
  const products = props.data;
  const items = products?.items;

  return (
    <div id="products" className="products-section">
      <div className="container">
        <div className="products-header">
          <span className="products-eyebrow">
            {products?.eyebrow ?? "Products"}
          </span>
          <h2 className="products-title">
            {products?.title ?? "Loading..."}
          </h2>
        </div>

        <div className="products-capabilities">
          <span className="products-capabilities-eyebrow">
            {products?.capabilitiesTitle ?? "Key Capabilities"}
          </span>

          <div className="products-capabilities-grid">
            {items
              ? items.map((d, i) => (
                  <div key={`${d.title}-${i}`} className="capability-item">
                    <div className="capability-icon" aria-hidden="true">
                      <i className={d.icon}></i>
                    </div>
                    <div className="capability-content">
                      <h3 className="capability-title">{d.title}</h3>
                      <p className="capability-text">{d.text}</p>
                    </div>
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
